module.exports = "<!-- popover template -->\n<div>\n\t<p>{{info.content}}</p>\n</div>\n";